import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import SEO from "../components/SEO";

export default function PatientStories() {
  const [stories, setStories] = useState([]);
  useEffect(() => { api.get("/patient-stories").then(({ data }) => setStories(data)).catch(() => {}); }, []);

  return (
    <>
      <SEO title="Cochlear Implant Patient Stories from India" description="Real journeys of children and adults who got their hearing back through cochlear implants. Stories from across India." />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">Patient Stories</h1>
          <p className="mt-5 text-slate-700 text-[1.05rem]">Real children, real adults, real journeys from across India. Every story shared with consent.</p>
        </div>
      </section>

      <section className="hc-container py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {stories.map((s) => (
          <article key={s.id} data-testid={`story-${s.patient_name?.split(" ")[0]?.toLowerCase()}`} className="card-hc">
            {s.image && <img src={s.image} alt={s.patient_name} className="rounded-xl w-full aspect-[4/3] object-cover" />}
            <div className="mt-4 text-[12px] text-[#0F766E] font-semibold uppercase tracking-wider">
              {s.patient_type === "child" ? "Child" : "Adult"} · {s.city}
            </div>
            <div className="mt-1 font-serif text-lg font-semibold text-slate-900 leading-snug">{s.patient_name}</div>
            <p className="mt-2 text-slate-600 text-[14.5px] leading-relaxed">{s.summary}</p>
            {s.quote && <blockquote className="mt-4 border-l-2 border-[#0F766E] pl-3 italic text-slate-700 text-[14.5px]">"{s.quote}"</blockquote>}
          </article>
        ))}
      </section>

      <section className="hc-container pb-16">
        <div className="bg-gradient-to-br from-[#0369A1] to-[#0F766E] text-white rounded-3xl p-8 md:p-12 text-center">
          <h2 className="font-serif text-2xl md:text-3xl font-semibold">Share your CI journey</h2>
          <p className="mt-3 text-sky-50 max-w-2xl mx-auto">Your story can give another family hope. Submit your story with consent — our editorial team will reach out to verify and publish.</p>
          <Link to="/register" data-testid="submit-story-cta" className="mt-6 inline-flex bg-white text-[#0369A1] hover:bg-sky-50 font-semibold rounded-xl px-6 py-3">Submit your story</Link>
        </div>
      </section>
    </>
  );
}
